import {styled} from "@mui/material/styles"
import {FALLBACK_FONT_FAMILY, breakpoints} from "@next/ux-fabric"

type TitleProps = {
    linkColour: string
    fontWeight: string
    isFirstElement?: boolean
}

export const Title = styled("div")<TitleProps>`
    padding-left: 1rem;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0;
    letter-spacing: ${({theme}) => theme.uxfabric.global.subtitle2.letterSpacing}px;
    word-break: break-word;
    color: ${({theme, linkColour}) => linkColour || theme.uxfabric.text.primary};
    font-family: ${({theme}) => `${theme.uxfabric.global.subtitle2.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
    line-height: ${({theme}) => theme.uxfabric.global.subtitle2.lineHeight};
    font-weight: ${({theme, fontWeight}) => fontWeight || theme.uxfabric.global.subtitle2.fontWeight};
    text-transform: ${({theme}) => theme.uxfabric.global.subtitle2.textTransform};
    font-size: ${({theme}) => theme.uxfabric.global.subtitle2.fontSize};

    @media (min-width: ${breakpoints.values.md}px) {
        padding-left: 2rem;
    }
    @media (min-width: ${breakpoints.values.lg}px) {
        height: unset;
        padding-left: 0;
        font-size: ${({theme}) => theme.uxfabric.global.subtitle2.fontSize};
        font-weight: ${({theme, fontWeight}) => fontWeight || theme.uxfabric.global.subtitle2.fontWeight};
        margin: ${({isFirstElement}) => (isFirstElement ? "0 0 0.75rem 0" : "1.25rem 0 0.75rem")};
        background: none;
    }

    // This is to overide MVC changes
    & > span {
        font-family: ${({theme}) =>
            `${theme.uxfabric.global.subtitle2.fontFamily}, ${FALLBACK_FONT_FAMILY}`} !important;
        font-weight: ${({theme}) => theme.uxfabric.global.subtitle2.fontWeight};
        letter-spacing: ${({theme}) => theme.uxfabric.global.subtitle2.letterSpacing}px;
    }
`
